<template>
<div class="wrapper">
    <notifications></notifications>
    <side-bar>
        <template #links>
            <!-- <sidebar-item v-if="role == 3"  :link="{
        name: 'DASHBOARD',
        path: '/dashboardSkg',
        icon: 'ni ni-tv-2 text-primary'
      }" />

            <sidebar-item v-if="role == 3"  :link="{
        name: 'CARIAN MAKLUMAT PEGAWAI',
        path: '/setMaklPer',
        icon: 'ni ni-zoom-split-in text-info'
      }" /> -->

            <!-- <sidebar-item v-if="role == 3"  :link="{
        name: 'MANAGE PEGAWAI',
        path: '',
        icon: 'ni ni-collection text-success'
      }">
                <sidebar-item :link="{
          name: 'DAFTAR PEGAWAI',
          path: '/DaftarPegawai',
          icon: 'ni ni-single-02 text-secondary'
        }" />
                <sidebar-item :link="{
          name: 'DASHBOARD PENTADBIR BGE',
          path: '/DashboardPentadbirBGE',
          icon: 'ni ni-single-02 text-secondary'
        }" />
            </sidebar-item> -->
            <!-- <sidebar-item v-if="role == 3" :link="{
        name: 'FASI BGE',
        path: '',
        icon: 'ni ni-collection text-success'
      }">
                <sidebar-item :link="{
          name: 'DAFTAR PEGAWAI',
          path: '/DaftarPegawai',
          icon: 'ni ni-single-02 text-secondary'
        }" />
                <sidebar-item :link="{
          name: 'DASHBOARD FASI BGE',
          path: '/DashboardFasiBGE',
          icon: 'ni ni-single-02 text-secondary'
        }" />
            </sidebar-item> -->
            <sidebar-item v-if="role == 2 || role == 3" :link="{
        name: 'PEGAWAI BGE',
        path: '',
        icon: 'ni ni-collection text-success'
      }">
                <sidebar-item :link="{
          name: 'DAFTAR PROFIL PEGAWAI',
          path: '/DaftarKiraanPSM',
          icon: 'ni ni-single-02 text-secondary'
        }" />
                <sidebar-item :link="{
          name: 'DASHBOARD',
          path: '/dashboardSkg',
          //path: '/DashboardPSMBGE',
          icon: 'ni ni-single-02 text-secondary'
        }" />
            </sidebar-item>
            <sidebar-item v-if="role == 4" :link="{
        name: 'PEGAWAI PSM',
        path: '',
        icon: 'ni ni-collection text-success'
      }">
                <sidebar-item :link="{
          name: 'DAFTAR PROFIL PEGAWAI',
          path: '/DaftarKiraanPSM',
          icon: 'ni ni-single-02 text-secondary'
        }" />
                <sidebar-item :link="{
          name: 'DASHBOARD',
          path: '/dashboardSkg',
          //path: '/DashboardPSMBGE',
          icon: 'ni ni-single-02 text-secondary'
        }" />
            </sidebar-item>
            <sidebar-item v-if="role == 3" :link="{
        name: 'SELENGGARA PENGGUNA',
        path: '/selenggaraPengguna',
        icon: 'ni ni-settings-gear-65 text-warning'
      }">
            </sidebar-item>
            <sidebar-item :link="{
        name: 'BORANG',
        path: '',
        icon: 'ni ni-collection text-success'
      }">
                <sidebar-item :link="{
    name: ' JADUAL GAJI KHAS UNTUK PENYANDANG',
    path: '#',   // dummy path supaya item muncul
    icon: 'ni ni-cloud-download-95 text-info'
  }" @click.native.prevent="downloadManual" />
</sidebar-item>
                <sidebar-item :link="{
    name: ' MANUAL PENGGUNA',
    path: '#',   // dummy path supaya item muncul
    icon: 'ni ni-cloud-download-95 text-info'
  }" />

        </template>
    </side-bar>

    <div class="main-content">
        <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

        <div @click="$sidebar.displaySidebar(false)">
            <fade-transition :duration="200" origin="center top" mode="out-in">
                <!-- your content here -->
                <router-view></router-view>
            </fade-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
</div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
    if (hasElement(className)) {
        new PerfectScrollbar(`.${className}`);
    } else {
        // try to init it later in case this component is loaded async
        setTimeout(() => {
            initScrollbar(className);
        }, 100);
    }
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import {
    FadeTransition
} from 'vue2-transitions';

export default {
    components: {
        DashboardNavbar,
        ContentFooter,
        DashboardContent,
        FadeTransition
    },
    methods: {
        downloadManual() {
            window.open('/files/JADUAL GAJI KUP - SSPA.docx', '_blank')
        },
        initScrollbar() {
            let isWindows = navigator.platform.startsWith('Win');
            if (isWindows) {
                initScrollbar('sidenav');
            }
        }
    },
    mounted() {
        this.initScrollbar()
    },
    computed: {
        role() {
            return this.$store.state.Pengguna.roleID
        }
    },

};
</script>

<style lang="scss">
</style>
